import {ExitLayer} from '@travel-frontend/ui-components';

import {useTracking} from '@/modules/common/hooks/useTracking';

type Props = {
  config: React.ComponentProps<typeof ExitLayer>['config'];
};

export const ExitIntentLayerDefault: React.FunctionComponent<Props> = ({
  config,
}) => {
  const {dispatchGenericTrackingEvent} = useTracking();

  const handleClose = () => {
    dispatchGenericTrackingEvent({
      event: 'find',
      event_action: 'exit_layer_closed',
    });
  };

  return (
    <ExitLayer
      delay={15_000}
      config={config}
      onClose={handleClose}
      onCTAClick={handleClose}
      onLoad={() => {
        dispatchGenericTrackingEvent({
          event: 'find',
          event_action: 'exit_layer_loaded',
        });
      }}
    />
  );
};
